import { VideoScriptPanel } from "../components/VideoScriptPanel/index";
import VideoParamsPanel from "../components/VideoParamsPanel";
import { useVideoRewrite } from "./hooks";
import { TransitionPanel } from "../components/TransitionPanel";
import { useEffect, useState } from "react";
import Empty from "../components/Empty";
import { useAiStudioReady } from "../hooks";
import { useOpenWindow } from "@utils/window";
import "./index.scss";
import { PageHeader } from "@layouts/PageHeader";
import { useNavigationGuard } from "@layouts/NavigationGuard";
import { t } from "i18next";
import { useMembershipLevel } from "@hooks/membership";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { resetToInit } from "@store/globalAISlice";
import { handleSave, updateReady, resetToInit as resetScriptRewrite } from "./scriptRewriteSlice";
import { useQueryParams } from "@hooks/useQueryParams";
import classNames from "classnames";

export const ScriptRewrite = () => {
  useAiStudioReady(updateReady, resetToInit);

  const dispatch = useAppDispatch();
  const [showResult, setShowResult] = useState(false);
  const { openWindow } = useOpenWindow();
  const [refreshKey, setRefreshKey] = useState(0);
  const { isBasicUp } = useMembershipLevel();
  const [originalVideoID]: any = useQueryParams(["id"]);

  const { status, error, rewriteScriptList, isTranslateLoading } = useAppSelector(
    (state) => state.scriptRewriteReducer,
  );
  const shouldEnableNavigationGuard = status !== "idle" && !error;

  const { loopAITask, showTranslate, init, stopPolling, resetCancelled } = useVideoRewrite();

  const { showLeaveConfirm, GuardModal } = useNavigationGuard(shouldEnableNavigationGuard, {
    onConfirm: () => {
      stopPolling();
      setShowResult(false);
      dispatch(resetScriptRewrite());
      resetCancelled();
    },
  });

  useEffect(() => {
    if (status === "succeeded" && rewriteScriptList.length > 0) {
      const timer = setTimeout(() => {
        setShowResult(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [status, rewriteScriptList.length, error]);

  // 进入页面时重置状态
  useEffect(() => {
    dispatch(resetScriptRewrite());
  }, []);

  // 初始化
  useEffect(() => {
    init();
  }, [originalVideoID]);

  if (!isBasicUp || error) {
    return (
      <Empty
        image="8903ffad.png"
        tips={error?.message || "Sorry, You don't have permission to access this page."}
        label="Back to homepage"
        className="flex-1"
        handleBtnClick={() => {
          openWindow("/");
        }}
      />
    );
  }

  // 测试按钮，开发时可手动切换状态
  return (
    <div className="ScriptRewrite h-screen relative">
      {status !== "idle" && <PageHeader title={t("AI Script Writer")} onBack={showLeaveConfirm} />}
      <div className={classNames("flex justify-center", status === "idle" ? "h-full" : "h-[calc(100%-53px)]")}>
        <VideoParamsPanel showCard={status === "idle"} />
        {status !== "idle" && (
          <div className="flex-1 relative -top-[53px] z-10 h-screen kalo-shadow bg-kds-bg w-full ScriptRewriteContainer">
            {showResult ? (
              <VideoScriptPanel
                showProduct={false}
                isTranslateLoading={isTranslateLoading}
                data={rewriteScriptList}
                className="flex-1"
                status={status}
                handleTranslate={showTranslate}
                handleSave={(e) => {
                  dispatch(handleSave(e));
                }}
                onParseProductFailed={() => {
                  dispatch(resetScriptRewrite());
                }}
              />
            ) : (
              <TransitionPanel
                key={refreshKey}
                status={status}
                onRetry={() => {
                  setRefreshKey(refreshKey + 1);
                  loopAITask();
                }}
              />
            )}
          </div>
        )}
      </div>
      {GuardModal}
    </div>
  );
};
